export const breakpoints = {
  phone: 575,
  tabletS: 800,
  tablet: 1024,
  desktopS: 1280,
  desktop: 99999
};
